import {HandType} from '../../global/types/GlobalTypes';
import {Note} from './Note';

export type Handprint = Note[];

export class HandprintName {
  bloc: string = '';
  LEFT: string = '';
  RIGHT: string = '';
}

export class TextDisplay {
  count: string = '';
  partName: string = '';
  lyrics: string = '';
  sectionName: string = '';

  handprintNameOnChange: HandprintName = new HandprintName();
}

export interface PositionNote {
  key: number;
  hand: HandType;
  finger: string;
}

export interface MelodyNote {
  key: number;
  duration: number;
  noteStatus: number;
}

export class Division {
  id: number = -1;
  partId: number = -1;
  partIndex: number = -1;
  sectionId: number = -1;

  textDisplay: TextDisplay = new TextDisplay();

  currentHandprint: Handprint = [];
  nextHandprint: Handprint = [];
  position: PositionNote[] = [];
  melodyNote: MelodyNote = {key: -1, duration: -1, noteStatus: 0};

  // get handprintBlocId = json.divisions[z].leftHandprintId + '_' + json.divisions[z].rightHandprintId

  /**
   * Return nextHandprint and position in a new Division model;
   * @param division
   */
  static divisionAsNextHandprintDivisionForPiano(division: Division): Division {
    const result = new Division();
    result.nextHandprint = division.currentHandprint;
    result.position = division.position;
    return result;
  }
}
